<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params)">
      <span>{{ modifiedStatus(params) }}</span>
    </vs-chip>
</template>

<script>
import moment from "moment"
    export default {
        name: 'CellRendererStatus',
        computed: {
          chipColor() {
            return (value) => {
              if(value.value === "cleared"){
                return "success"
              }
              else if(value.value === "pending"){
                if( value.data.cleared_on != null && moment().diff( moment(value.data.cleared_on) , 'days') > 0 ){
                  return "primary"
                }

                return "dark"
              }
              else{
                return "danger"
              }
            }
          },
          modifiedStatus(){
            return (value) => {
              if(value.value === "cleared"){
                return "Funds cleared"
              }
              else if(value.value === "pending"){

                if( value.data.cleared_on != null && moment().diff( moment(value.data.cleared_on) , 'days') > 0 ){
                  return "Funds are ready"
                }

                return "Release on " + value.data.cleared_on
              }
              else{
                return "Delivery in progress"
              }
            }
          },
          release_date( val ){

              if( val != null ){
                return moment().diff( moment(val) , 'days')
              }

              return 0

            },
        }
    }
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
